import webhooks_gen_2 from '@devices/settings/device_settings/webhooks_gen_2.js';
import networks_gen_2_plus_sleeping from '@devices/settings/device_settings/networks_gen_2_plus_sleeping.js';
import app from '@devices/settings/device_settings/app.js';
import share from '@devices/settings/device_settings/share.js';

export default {
	name: 'ShellySmokeLTE',
	friendly_name: 'Smoke LTE',
	family: 'sensor',
	isPM: false,
	modes: {
		sensor: {
			availableViews: ['basic'],
			channels: 1,
			notifications: ['offline', 'device_problem', 'smokeAlarm', 'lowBattery'],
			settings: [
				webhooks_gen_2,
				networks_gen_2_plus_sleeping,
				app,
				share,
				{
					title: 'settings',
					components: [
						{ title: 'device_name', component: 'device_name_sys' },
						{ title: 'firmware_version', component: 'firmware_update' },
						{
							title: 'temperature_threshold',
							component: 'temperature_threshold_ble',
						},
						{
							title: 'smoke_threshold',
							component: 'smoke_threshold_ble',
						},
						{
							title: 'fire_group',
							component: 'fire_group_ble',
						},
						{ title: 'device_information', component: 'device_information' },
					],
				},
			],
		},
	},
};
